import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GoogleInfoWindowService {

  private aaInfoWindow: any;

  constructor() {
    this.createInfoWindow();
  }

  private createInfoWindow(): void {
    this.aaInfoWindow = new google.maps.InfoWindow({
      content: '',
      maxWidth: 260
    });
  }

  open(googleMap, marker) {
    if (this.aaInfoWindow) {
      this.aaInfoWindow.open(googleMap, marker);
    }
  }

  close() {
    if (this.aaInfoWindow) {
      this.aaInfoWindow.close();
    }
  }

  setContent(html) {
    if (this.aaInfoWindow) {
      this.aaInfoWindow.setContent(html);
    }
  }

}
